import { stopParkingSpot } from '@api/parking-spots';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from '@ui/components';

export const useParkingSpotStopDialog = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation();
  const { mutate: stopParking, isPending: isStopParkingPending } = useMutation({
    mutationFn: stopParkingSpot,
    onSuccess: () => {
      onSuccess();
      toast.success(t(`PARKING_SPOTS.STOP_PARKING_SUCCESS`));
    },
    onError: () => {
      toast.error(t(`API_ERRORS.DEFAULT`));
    },
  });

  return { stopParking, isStopParkingPending };
};
